/** Clickable card representing one skill choice on level-up. */
export function SkillCard({ skill, onChoose }) {
  return (
    <button className="skill-card" onClick={() => onChoose(skill)}>
      <strong>{skill.label}</strong>
      <span>{skill.desc}</span>
    </button>
  );
}
